export interface CustomPlayerTheme {
  primaryColor: string;
  accentColor: string;
  backgroundColor: string;
  panelBackgroundColor: string;
  textColor: string;
  secondaryTextColor: string;
  progressColor: string;
  controlColor: string;
  overlayColor: string;
  pillBackgroundColor: string;
  pillBorderColor: string;
  fontFamily: string;
}

export interface CustomPlayerFeatures {
  quality: boolean;
  subtitles: boolean;
  audioTracks: boolean;
  playbackSpeed: boolean;
  chapters: boolean;
  trickPlay: boolean;
  upNext: boolean;
  miniPlayer: boolean;
  floatingPlayer: boolean;
  pip: boolean;
  watermark: boolean;
  airPlay: boolean;
  report: boolean;
  like: boolean;
  dislike: boolean;
  share: boolean;
  skipIntro: boolean;
}

export const defaultCustomPlayerTheme: CustomPlayerTheme = {
  primaryColor: '#FFFFFF',
  accentColor: '#FFA823',
  backgroundColor: '#000000',
  panelBackgroundColor: 'rgba(30, 33, 48, 0.85)',
  textColor: '#FFFFFF',
  secondaryTextColor: 'rgba(255, 255, 255, 0.7)',
  progressColor: '#FFA823',
  controlColor: '#FFFFFF',
  overlayColor: 'rgba(5, 8, 25, 0.4)',
  pillBackgroundColor: 'rgba(255, 255, 255, 0.1)',
  pillBorderColor: 'rgba(255, 255, 255, 0.15)',
  fontFamily: '"Poppins", sans-serif',
};

export const defaultCustomPlayerFeatures: CustomPlayerFeatures = {
  quality: true,
  subtitles: true,
  audioTracks: true,
  playbackSpeed: true,
  chapters: true,
  trickPlay: true,
  upNext: true,
  miniPlayer: true,
  floatingPlayer: false,
  pip: true,
  watermark: false,
  airPlay: false,
  report: true,
  like: true,
  dislike: true,
  share: true,
  skipIntro: true,
};

export const themeToCssVars = (theme: CustomPlayerTheme): Record<string, string> => ({
  '--player-primary': theme.primaryColor,
  '--player-accent': theme.accentColor,
  '--player-background': theme.backgroundColor,
  '--player-panel-bg': theme.panelBackgroundColor,
  '--player-text': theme.textColor,
  '--player-text-secondary': theme.secondaryTextColor,
  '--player-progress': theme.progressColor,
  '--player-control': theme.controlColor,
  '--player-overlay': theme.overlayColor,
  '--player-pill-bg': theme.pillBackgroundColor,
  '--player-pill-border': theme.pillBorderColor,
  '--player-font': theme.fontFamily,
});
